<div #container class="dragdealer" [ngClass]="dragging && 'dragging'" tabindex="0">
  <div class="bar-container">
    <div class="bar"></div>
  </div>
  <div class="handle" fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="space-around center">
    <i class="fa fa-caret-left"></i>
    <ng-content></ng-content>
    <i class="fa fa-caret-right"></i>
  </div>
</div>
